var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAuditbotRunsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4076_2204)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 358.42,
    cy: 152.475,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(-1 0 0 1 57.4219 136.634)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.162,
    cy: 200,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(-1 0 0 1 31.6797 184.158)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.42,
    cy: 247.525,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(-1 0 0 1 57.4219 231.684)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.474,
    cy: 41.5838,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(1 0 0 -1 136.633 374.258)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.998,
    cy: 15.8416,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(1 0 0 -1 184.156 400)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.521,
    cy: 41.5838,
    r: 15.8416,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8416,
    cy: 15.8416,
    r: 15.8416,
    transform: "matrix(1 0 0 -1 231.68 374.258)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.611 95.0498C114.551 95.0498 95.0469 114.554 95.0469 138.614V261.386C95.0469 285.446 114.551 304.951 138.611 304.951H261.384C285.443 304.951 304.948 285.446 304.948 261.386V138.614C304.948 114.554 285.443 95.0498 261.384 95.0498H138.611ZM237.621 157.323H261.136C265.055 157.522 268.386 158.912 271.13 161.495C273.677 164.277 275.049 167.654 275.245 171.628V205.006H124.75V171.628C124.946 167.654 126.318 164.277 128.865 161.495C131.608 158.912 134.94 157.522 138.859 157.323H162.374V143.018C162.57 139.044 163.941 135.667 166.489 132.885C169.232 130.303 172.563 128.912 176.483 128.713H223.512C227.432 128.912 230.762 130.303 233.506 132.885C236.053 135.667 237.425 139.044 237.621 143.018V157.323ZM176.483 157.323H223.512V143.018H176.483V157.323ZM214.106 233.114C217.046 232.905 218.613 231.231 218.809 228.094V213.037H275.245V258.21C275.049 262.393 273.677 265.948 271.13 268.876C268.386 271.594 265.055 273.059 261.136 273.268H138.859C134.94 273.059 131.608 271.594 128.865 268.876C126.318 265.948 124.946 262.393 124.75 258.21V213.037H181.185V228.094C181.381 231.231 182.949 232.905 185.888 233.114H214.106Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.969,
    y: 148.515,
    width: 41.5842,
    height: 7.92079,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.5842,
    height: 7.92079,
    transform: "matrix(-1 0 0 1 97.0312 148.515)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.969,
    y: 196.04,
    width: 67.3267,
    height: 7.92079,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.3267,
    height: 7.92079,
    transform: "matrix(-1 0 0 1 97.0312 196.04)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.969,
    y: 243.564,
    width: 41.5842,
    height: 7.92079,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.5842,
    height: 7.92079,
    transform: "matrix(-1 0 0 1 97.0312 243.564)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.516,
    y: 53.4658,
    width: 7.92079,
    height: 41.5842,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.92079,
    height: 41.5842,
    transform: "matrix(1 0 0 -1 148.516 346.535)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.039,
    y: 29.7031,
    width: 7.92079,
    height: 65.3465,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.92079,
    height: 65.3465,
    transform: "matrix(1 0 0 -1 196.039 370.297)",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.562,
    y: 53.4658,
    width: 7.92079,
    height: 41.5842,
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.92079,
    height: 41.5842,
    transform: "matrix(1 0 0 -1 243.562 346.535)",
    fill: "#3CDBC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4076_2204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAuditbotRunsIcon);
export default __webpack_public_path__ + "static/media/no_auditbot_runs_icon.9064afad.svg";
export { ForwardRef as ReactComponent };